import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3">
					…kaj tiam komenciĝis aktiva produktado de pupoj en tutplaneda skalo. 
					Komence tio estis nur pupoj-inoj kun longaj etenditaj kapharoj kaj sep diversaj kalibroj de seksa truo. 
					Tamen baldaŭ ankaŭ virinoj (dua sekso en la duseksa vivsistemo sur la planedo) ekdeziris samajn privilegiojn kaj oportunaĵojn, kiujn donis la ĉeesto de ĉiam preta partnero. 
					Jam antaŭe oni komencis produkti vibrilojn, kiuj aspektis kiel nura vira seksorgano, ĉiam de la sama grandeco kaj longo; 
					kaj dum la uzado virino devis mem teni ĝin enmane, kio evidente estis neoportune kaj ne lasis iluzion de «ama akto». 
				</p>
				
				<p class="mb-3">
					Sed apero de pupoj-inoj kun «mola varma haŭto, kiun eĉ eblis transplanti al homoj dum operacioj» fariĝis turnopunkto en tiu ĉi epopeo. 
					Ankaŭ virinoj ekdeziris varman haŭton kaj ardajn brakumojn.
				</p>
				
				<p class="mb-3">
					La pupoj-maskloj ankaŭ estis produktataj laŭ kalibroj; sed krom longeco kaj dikeco, eblis tre facile reguligi durecon kaj frekvencon de osciloj. 
					Kaj, kio tre gravas, la roboto-masklo kun varma haŭto kaj teneraj brakoj povis karesi kaj flustri al orelo ajnajn vortojn, 
					laŭ la deziro de mendantino. 
					Ĉu eblis kompari kun li la mizerajn vivantajn kopiojn de tia perfekta partnero!
				</p>
				
				<p class="mb-3">
					Krom tio, la pupoj-maskloj povis plenumi ankaŭ aliujn funkciojn. 
					Baldaŭ oni jam vaste uzis ilin en kosmetikaj kaj kuracaj celoj. 
					Kompreneble, en la certa loko de la torso de la roboto troviĝis saketo kun ŝmiraĵo, t.e. sennoca lubrikanto, kiu estis eligata ankaŭ dum imito de orgasmo. 
					Tamen, virinoj baldaŭ komprenis, ke en tiun rezervujon eblas alverŝi ne nur substancojn speciale por seksumado, sed ankaŭ, ekzemple, kuracsolvaĵojn por enŝprucigo, 
					vitaminajn miksaĵojn, kaj eĉ simple aromajn substancojn, por ke la virino jam bonodoru de ĉiuj flankoj. 
					Por kiujn allogi? Ĉu por vivantaj viroj? Sed kiu ja bezonas ilin! Tio estis konkuro inter virinoj. 
				</p>
				
				<p class="mb-3">
					Tiamaniere estis reorganizita kaj parfum-, kaj farmaci-industrio; pli kaj pli ilia produktaĵo estis destinita por intrakorpa apliko. 
					En la socio kun dominado de viroj tia ebleco eĉ ne ekzistis; sed kiam oni ekkonsideris ĝin, aperis novaj, tute neatenditaj perspektivoj. 
					Evidentiĝis, ke post negranda operacio eĉ nutraĵon eblas enigi al la organismo «tra malsupro». 
					Tio kondukis al ankoraŭ unu kardinala ŝanĝo en la vivmaniero de la popolo: plene rekonstruiĝis nutraĵindustrio, kuniĝinte kun farmakologio: 
					la nutraĵoj jam estas ekvilibrigitaj laŭ ĉiuj parametroj, kaj sur la planedo ĉesis kultivado de brutoj por manĝo kaj kreskigado de grenoj kaj aliuj nutraĵplantoj sur enormaj areoj. 
					La biotopo de la planedo venis al la stato de ekvilibro, kaj tiam aliuj racihavaj estaĵoj, antaŭe sin kaŝintaj en foraj neatingeblaj lokoj aŭ sur la fundo de oceano, 
					ricevis la rajton por vivi. 
				</p>
				
				<p class="mb-3">
					Dume ĉe inoj de «la sola racihava specio» (laŭ ilia opinio) pro la ŝanĝo de la manĝmaniero degeneris la vasta digestaparato kaj ene de la korpo liberiĝis multe da loko. 
					Kaj la korpo mem malpligrandiĝis, ĉar jam ne postulis grandajn porciojn de kruda manĝaĵo. 
				</p>
				
				<p class="mb-3">
					Sed kio pri alia sekso de tiu duseksa sistemo, la t.n. «viroj»? 
				</p>
				
				<p class="mb-3">
					Kompreneble, ili ne intencis forlasi siajn privilegiojn; tamen, ĉu eblas ja haltigi la evoluon? Liberigitaj de sia dependeco de viroj, virinoj neimageble rapide, plenforte komencis disvolvi novajn terenojn de scienco, pleparte ligitajn kun la naturo, tiamaniere fakte ĉesiginte la maŝinan civilizon. La viroj kiel apatraj estaĵoj praktike ne plu estis bezonataj por daŭrigo de  la homa vivo surplanede, ĉar ekeblis simple preni de ili la fekundigan substancon kaj enigi ĝin en la pupon-masklon.
				</p>
				
				<p class="mb-3">
					Kaj tiam iu el inoj faris la krucpaŝon: per rimedoj de gena inĝenierio el senesperintaj, al neniu bezonataj maskloj, 
					kiuj ne povis trovi por si lokon en la vivo kaj amase suicidis, 
					estis eliminitaj gonadoj kaj poste transigitaj en la liberiĝintan lokon en la korpo de inoj. 
					Tiel la «racihava loĝantaro» de la planedo estis savita de plena formortado: la korpoj de maskloj elsekiĝis kaj malaperis de la vizaĝo de la planedo; sed iliaj seksorganoj estis de nun sekure instalitaj en la korpojn de inoj. Tio estis dua etapo de vivevoluo sur tiatipaj planedoj: dekomence interna fekundigo kaj embriogenezo en la korpo de ino, poste lokigo tien ankaŭ la kontraŭan seksulon por eviti la nerenkonton de gepatroj kaj sekurigi la fertilecon, por ke la vivo daŭru. 
				</p>
				
				<p class="mb-3">
					Naskiĝas, kiel kutime, knaboj kaj knabinoj; ĉe novnaskitaj knaboj oni prenas la seksan aparaton kaj enigas ĝin en la organismon de novnaskitaj knabinoj, 
					kie ili kreskas kaj disvolviĝas kune. 
					Ĝuste tio estas «vira parasitismo» en ĝia biologia senco. 
					Post atingo de seksa matureco la inoj povas fekundiĝi kaj naski idojn laŭ sia volo kaj deziro. 
				</p>
				
				<p class="mb-3">
					La sola afero, kiun ni ĝis nun ne scias – kion oni faras kun la korpoj de novnaskitaj knaboj. 
					Sed ni esperas, ke pliaj observoj kaj esploroj donos respondon ankaŭ al tiu demando. 
				</p>


				<table class="mb-5" style="width: 100%;">
					<tbody>
						<tr>
							<td style="text-align: left;">
								<div style="padding-left: 30px;">
									Piloto: ()
								</div>
							</td>
							<td style="text-align: right;">
								<div style="padding-right: 30px;">
									Dato: ()
								</div>
							</td>
						</tr>
					</tbody>
				</table>
 
				<p class="mb-5">
					(La rakonto estas bazita sur du citaĵoj de Stanislaw Lem)
				</p>
			</div>
    `
  )
}

const itemName = {
  esp: 'Fragmento el hazarde konservita speciala raporto de piloto () el Kosma Kontrolo, kiu vizitis la planedon 3864 por vica kontrolo post 42 rungmoj'
}

const itemDate = {
  rus: '24-28 de januaro, 2023'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 